import {
  ChangeDetectionStrategy,
  Component,
  input,
  output,
} from '@angular/core';
import { MatRipple } from '@angular/material/core';
import { MatRadioButton } from '@angular/material/radio';
import { NgCommonModule } from '@principle-theorem/ng-shared';
import { ContentContainerComponent } from '../content-container/content-container.component';

@Component({
  selector: 'pr-radio-button-card',
  templateUrl: './radio-button-card.component.html',
  styleUrl: './radio-button-card.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'flex' },
  imports: [
    NgCommonModule,
    MatRadioButton,
    MatRipple,
    ContentContainerComponent,
  ],
})
export class RadioButtonCardComponent {
  value = input.required<unknown>();
  checked = input<boolean>();
  clicked = output<void>();
}
